import { render, staticRenderFns } from "./newRefItem.vue?vue&type=template&id=014be6c2&"
import script from "./newRefItem.vue?vue&type=script&lang=js&"
export * from "./newRefItem.vue?vue&type=script&lang=js&"
import style0 from "./newRefItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports